import type { CarrierContactPrefill } from "~/shared/documents/schemas/carrier-contact-prefill.schema";

export const CARRIER_CONTACT_PREFILL_DESCRIPTION = "Prefilled from carrier contacts with the Logistics document type.";

/** Dim helper copy for create-modal carrier contact fields. */
export const describeCarrierContactPrefill = (_prefill: CarrierContactPrefill): string => CARRIER_CONTACT_PREFILL_DESCRIPTION;
